exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.feature-toggle__contents{width:273px;background-color:#fbfbfb}.feature-toggle__caption{height:33px;font-family:Open Sans,sans-serif;color:#2c2c2c;font-size:24px}.feature-toggle__toggle{position:relative;display:flex;align-items:center;width:273px;height:48px;margin-top:20px;margin-left:17px}.feature-toggle__toggle .toggle-caption{height:24px;line-height:24px;font-family:Open Sans,sans-serif;font-size:16px;font-weight:600}.feature-toggle__toggle .toggle-button{position:absolute;right:16px;width:40px;height:24px;top:4px}.feature-toggle__explanation{font-family:Open Sans,sans-serif;font-size:12px;color:#9b9b9b;font-style:italic;height:102px;width:242px;margin-top:8px;padding-bottom:16px;margin-left:17px}.feature-toggle__explanation p{margin:0;padding:0}.feature-toggle__explanation .learn-more{margin-top:18px}.feature-toggle__explanation .email-link{margin:0;padding:0;font-style:normal;color:#00e;text-decoration:underline;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/FeatureToggle/FeatureToggle.scss
// module id = 1559
// module chunks = 0